export default __webpack_public_path__ + "static/media/propTick.724807b9.svg";